import ApiCore from '../api-core'
import { ACTIVE_BASE_REST } from '../constants'

export default class CreateOrder extends ApiCore {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/order/create`)
  }

  furniture(model, showProgress) {
    return this._request({
      action: 'furniture',
      method: 'POST',
      body: model,
      showProgress
    })
  }

  cargo(model, showProgress) {
    return this._request({
      action: 'cargo',
      method: 'POST',
      body: model,
      showProgress
    })
  }

  postage(model, showProgress) {
    return this._request({
      action: 'postage',
      method: 'POST',
      body: model,
      showProgress
    })
  }

  delivery(model, showProgress) {
    return this._request({
      action: 'delivery',
      method: 'POST',
      body: model,
      showProgress
    })
  }

  pickup(model, showProgress) {
    return this._request({
      action: 'pickup',
      method: 'POST',
      body: model,
      showProgress
    })
  }

  trash(model, showProgress) {
    return this._request({
      action: 'trash',
      method: 'POST',
      body: model,
      showProgress
    })
  }

  freight(model, showProgress) {
    return this._request({
      action: 'freight',
      method: 'POST',
      body: model,
      showProgress
    })
  }
}
